// src/hooks/nationalities/useDeleteAllNationalities.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllNationalities as deleteAllNationalitiesAPI } from "../../api/apiNationalities";
import parseError from "../../utils/parseError";

const useDeleteAllNationalities = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteAll, isPending: isDeleteAll } = useMutation({
        mutationFn: deleteAllNationalitiesAPI,
        onSuccess: (res) => {
            const message = res?.message || "Selected nationalities deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["nationalities"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete selected nationalities");
        },
    });

    return { deleteAllNationalities: deleteAll, isDeleteAll };
};

export default useDeleteAllNationalities;